import { FuriganaVerticalIcon } from './FuriganaVerticalIcon';

/**
 * author: Haley Halcyon
 * id 68042B53-6F94-4EE1-A40D-9415AE0EE14A
 * name furigana-vertical
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/furigana-vertical.svg
 * tags
 * - Text / Content / Format 
 */
export const RubyVerticalIcon = FuriganaVerticalIcon;
export default RubyVerticalIcon